import Glide from "@glidejs/glide"

document.addEventListener("DOMContentLoaded", () => {
  const sliders = document.querySelectorAll(".glide.glide-banner")
  for (let i = 0; i < sliders.length; i++) {
    if (sliders[i]) {
      new Slider(sliders[i])
    }
  }
})

class Slider {
  constructor(sliderContainer) {
    this.slider = new Glide(sliderContainer, {
      type: "carousel",
      perView: 1,
      gap: 0,
      autoplay: 4500,
      hoverpause: false,
      animationDuration: 0,
      keyboard: false,
    }).mount()
  }
}
